import React from "react";
import Nav from "../components/genericLayout/nav/Nav";
import Footer from "../components/genericLayout/footer/Footer";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import styles from "./AziendaZeroLayout.module.css";
import Home from "./home/home";
import RicercaSegnalazioni from "./ricercaSegnalazioni/ricercaSegnalazioni";
import "../services/Interceptor";
import history from "../utils/History";
import { navbarLink as navLink } from "../config/menuConfig";
import { navbarLinksHIV as navLinksHIV } from "../config/menuConfig";
import { profileDropdownList as menuUtente } from "../config/menuUtenteConfig";
import Interceptor from "../services/Interceptor";
import WizardPanel from "./Wizard/WizardPanel/WizardPanel";
import RicercaFocolaio from "./gestioneFocolai/ricercaFocolaio/ricercaFocolaio";
import AssociaSegnalazioni from "./gestioneFocolai/informazioniFocolaio/associaSegnalazioni/AssociaSegnalazioni";
import InformazioniFocolaio from "./gestioneFocolai/informazioniFocolaio/InformazioniFocolaio";
import authConfig from "../config/authConfig";
import SessioneUtente from "../sessionManager/SessioneUtente";
import InserimentoSegnalazioni from "../layouts/monitoraggio/InserimentoSegnalazioni";
import InvioSchedeSpeciali from "./monitoraggio/InvioSchedeSpeciali";
import ButtonTop from "../components/buttontop/ButtonTop";
import $ from "jquery";
import SorveglianzaTBCPolmonare from "./monitoraggio/SorveglianzaTBCPolmonare";
import ReportStatistici from "./utilita/ReportStatistici";
import Spinner from "../components/spinner/Spinner";
import auth from "../../src/utils/AthnAuth";
import ToasterSingleton from "../singleton/ToasterSingleton";
import globals from "../config/appconfig";
import toasterConfig from "../config/toasterConfig";
import LogoutOrNotAuthorized from "./LogoutOrNotAuthorized/LogoutOrNotAuthorized";
import Utils from "../utils/Utils";
import ReportEpatite from "./utilita/reportEpatite/ReportEpatite";
import RicercaContactTracing from "./ricercaContactTracing/RicercaContactTracing";
import StatoInvioPremal from "./monitoraggio/StatoInvioPremal";
import ExportSegnalazioni from "./monitoraggio/ExportSegnalazioni";
import ExportArbovirosi from "./monitoraggio/ExportArbovirosi";
import FormHIV from "./hiv/FormHIV/FormHIV";
import Ruoli from "../utils/Ruoli";
import HomeHIV from "./hiv/HomeHIV/HomeHIV";
import LoginSelect from "./LoginSelect/LoginSelect";
import RicercaSegnalazioniHIV from "./hiv/RicercaSegnalazioniHIV/RicercaSegnalazioniHIV";
import GestioneDuplicatiHIV from "./hiv/GestioneDuplicatiHIV/GestioneDuplicatiHIV";
import ConvertiSegnalazione from "./convertiSegnalazione/ConvertiSegnalazione";
import Manuali from "./manuali/Manuali";
import IntegrazioneLIS from "./monitoraggio/IntegrazioneLIS";
import SegnalazioniDaLIS from "./monitoraggio/SegnalazioniDaLIS";

auth.configurazione({
    auth: authConfig['attivazione-auth'],
    urlAthn: authConfig['url-redirect-auth'],
    applicationId: "SIRMI",
    samlTokenErrorFunction: (code, description) => {
        let mess =
            code && description
                ? "Si e verificato un problema nell'accedere ai servizi infrastrutturali (come ad esempio l'anagrafica). Contattare l'Helpdesk per sistemare la posizione fornendo il codice errore " +
                  code +
                  " - " +
                  description
                : "Si e verificato un problema nell'accedere ai servizi infrastrutturali (come ad esempio l'anagrafica).";
        ToasterSingleton.instance().aggiuntaToaster({
            type: "confirm", //in caso di problemi nel recuperare il tipo di toaster, lo mostro come errore
            text: [mess],
            timestamp: Date.now(),
        });
    },
    samlTokenResources: [
        `${globals["app-url-backend-anagrafica"]}/anagrafiche`,
        `${globals["app-url-backend-siavr"]}/getVaccinazioni`,
    ],
});

class AziendaZeroLayout extends React.Component {
    state = {
        session: null,
        prova: null,
        loggedIn: null,
        authorized: null,
        url: window.location.pathname,
        hiv: null,
        filtri: {},
        navLabel: {},
        notifiche: [],
        stepProgressReport: false,
    };

    showSpinner = false;

    constructor(props) {
        super(props);
        authConfig["LatestActivityTime"] = Date.now();
        this.creaFiltri = this.creaFiltri.bind(this);
        this.navLabel = this.navLabel.bind(this);
        this.listenerScroll = this.listenerScroll.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.redirectToHome = this.redirectToHome.bind(this);
        new Interceptor();
        this.listenerScroll();
    }

    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this);

        this.showSpinner = true;

        auth.recuperoSessione()
            .then((utente) => {
                let ok = Utils.checkStringInArray(utente.gruppi);
                if (ok) {
                    SessioneUtente.getInstance({
                        sessionId: "",
                        CodiceFiscale: utente.codiceFiscale,
                        userName: utente.nome,
                        userSurname: utente.cognome,
                        userRoles: utente.gruppi,
                        CodiceStruttura: utente.codiceStruttura,
                        StrutturaHIV: utente.strutturahiv,
                    });
                    let hiv = this.redirectToHome();
                    this.setState({ loggedIn: true, authorized: true, hiv: hiv});
                } else {
                    this.setState({ loggedIn: true, authorized: false });
                    let path = new URL(
                        authConfig["url-unauthorized"]
                    ).pathname;
                    this.showSpinner = false;
                    history.push(path);
                }

                this.showSpinner = false;
            })
            .catch((error) => {
                console.log("Not signed in");
                console.error(`Errore: ${error}`);
            });
    }

    aggiungiToaster(text) {
        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
        });
    }

    redirectToHome() {
        let path = "";
        let hiv = false;
        let selectedApp = sessionStorage.getItem("selectedApp");
        if (selectedApp) {
            if (selectedApp === "SIRMI") {
                path = new URL(authConfig["url-redirect-home"]).pathname;
            } else if (selectedApp === "HIV") {
                path = new URL(authConfig["url-redirect-home-hiv"]).pathname;
                hiv = true;
            }
        } else {
            if (SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione) {
                path = new URL(authConfig["url-login-select"]).pathname;
            } else if (SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_HIV.descrizione) {
                path = new URL(authConfig["url-redirect-home-hiv"]).pathname;
                sessionStorage.setItem("selectedApp", "HIV");
                hiv = true;
            } else {
                path = new URL(authConfig["url-redirect-home"]).pathname
                sessionStorage.setItem("selectedApp", "SIRMI");
            }
        }
        this.showSpinner = false;
        history.push(path);
        return hiv;
    }

    listenerScroll() {
        $(window).scroll(function () {
            if (window.scrollY > 500) {
                $("#buttonTopdiv").css("display", "block");
            } else {
                $("#buttonTopdiv").css("display", "none");
            }
        });
    }

    creaFiltri(filtri) {
        let stato = sessionStorage.getItem("filtriMonitoraggio")? JSON.parse(sessionStorage.getItem("filtriMonitoraggio")) : null
        if (stato && filtri && filtri.filtri) {
            filtri.filtri.stato = stato
        }
        this.setState(filtri);
    }

    navLabel(navLabel) {
        if (navLabel) {
            this.setState(navLabel);
        } else {
            this.setState({ navLabel: {} });
        }
    }

    componentDidUpdate() {
        this.updateUrl();
    }

    render() {
        if (this.state.loggedIn) {
            let home = this.state.hiv === true ? "/homeHIV" : "/home"
            return (
                <div>
                    {" "}
                    {this.showSpinner ? <Spinner /> : null}
                    <Router history={history}>
                        <Route
                            exact
                            path="/"
                            render={() => (
                                <Route
                                    exact
                                    path="/"
                                    render={() => <Redirect to={home} />}
                                />
                            )}
                        />

                        <div
                            style={{
                                margin: "auto",
                                width: "86%",
                                minHeight: "100vh",
                            }}
                            className={styles.styleContent.concat(
                                " shadow bg-white rounded"
                            )}
                        >
                            <Nav
                                profileDropdownList={menuUtente}
                                segnalazioni={this.state.notifiche}
                                filtri={this.state.filtri}
                                hiv={this.state.hiv}
                                navbarLink={this.state.hiv === true ? navLinksHIV : navLink}
                                navLabel={this.state.navLabel}
                            />
                            <div className={styles.styleSideAndContent}>
                                <div
                                    className={"container"}
                                    style={{
                                        overflow: "hidden",
                                        flex: -1,
                                        padding: "10px",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <Switch>
                                        <Route
                                            exact
                                            path="/home"
                                            render={() => {
                                                return (
                                                    <Home
                                                        setStatePadre={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/login-select"
                                            render={() => {
                                                return (
                                                    <LoginSelect
                                                        setStatePadre={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/homeHIV"
                                            render={() => {
                                                return (
                                                    <HomeHIV
                                                        setStatePadre={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/ricercaSegnalazioni"
                                            render={() => {
                                                return <RicercaSegnalazioni pathProvenienza={"/ricercaSegnalazioni"}/>;
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/ricercaSegnalazioniHIV"
                                            render={(props) => {
                                                return <RicercaSegnalazioniHIV
                                                    {...props}
                                                    navLabel={this.navLabel}/>;
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/ricercaContactTracing"
                                            render={() => {
                                                return (
                                                    <RicercaContactTracing pathProvenienza={"/ricercaContactTracing"}/>
                                                );
                                            }}
                                        />

                                        <Route
                                            exact
                                            path="/wizardSegnalazione"
                                            render={(props) => {
                                                return (
                                                    <WizardPanel
                                                        {...props}
                                                        navLabel={this.navLabel}
                                                    />
                                                );
                                            }}
                                        />

                                        <Route
                                            exact
                                            path="/convertiSegnalazione"
                                            render={(props) => {
                                                return (
                                                    <ConvertiSegnalazione
                                                        {...props}
                                                        navLabel={this.navLabel}
                                                    />
                                                );
                                            }}
                                        />

                                        <Route
                                            exact
                                            path="/manuali"
                                            render={(props) => {
                                                return (
                                                    <Manuali
                                                        {...props}
                                                        navLabel={this.navLabel}
                                                    />
                                                );
                                            }}
                                        />

                                        <Route
                                            exact
                                            path="/associaSegnalazioni"
                                            render={(props) => {
                                                return (
                                                    <AssociaSegnalazioni
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />

                                        <Route
                                            exact
                                            path="/InformazioniFocolaio"
                                            render={(props) => {
                                                return (
                                                    <InformazioniFocolaio
                                                        {...props}
                                                        navLabel={this.navLabel}
                                                    />
                                                );
                                            }}
                                        />

                                        <Route
                                            exact
                                            path="/ricercaFocolai"
                                            render={(props) => {
                                                return (
                                                    <RicercaFocolaio
                                                        {...props}
                                                        pathProvenienza={"/ricercaFocolai"}
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/inserimentoSegnalazioni"
                                            render={(props) => {
                                                return (
                                                    <InserimentoSegnalazioni
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        /><Route
                                            exact
                                            path="/integrazioniLIS"
                                            render={(props) => {
                                                return (
                                                    <IntegrazioneLIS
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        /><Route
                                            exact
                                            path="/segnalazioniDaLIS"
                                            render={(props) => {
                                                return (
                                                    <SegnalazioniDaLIS
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/invioSchedeSpeciali"
                                            render={(props) => {
                                                return (
                                                    <InvioSchedeSpeciali
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/esitoTBC"
                                            render={(props) => {
                                                return (
                                                    <SorveglianzaTBCPolmonare
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/statoInvioPremal"
                                            render={(props) => {
                                                return (
                                                    <StatoInvioPremal
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/exportSegnalazioni"
                                            render={(props) => {
                                                return (
                                                    <ExportSegnalazioni
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/exportArbovirosi"
                                            render={(props) => {
                                                return (
                                                    <ExportArbovirosi
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/reportStatistici"
                                            render={(props) => {
                                                return (
                                                    <ReportStatistici
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                        creaStepProgressReport={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/reportEpatite"
                                            render={(props) => {
                                                return (
                                                    <ReportEpatite
                                                        {...props}
                                                        creaFiltri={
                                                            this.creaFiltri
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/unauthorized"
                                            render={() => {
                                                return (
                                                    <LogoutOrNotAuthorized
                                                        authorized={
                                                            this.state
                                                                .authorized
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/formHIV"
                                            render={(props) => {
                                                return <FormHIV
                                                    {...props}
                                                    navLabel={this.navLabel}/>;
                                            }}
                                        />
                                        <Route
                                            exact
                                            path="/gestioneDuplicatiHIV"
                                            render={(props) => {
                                                return <GestioneDuplicatiHIV
                                                    {...props}
                                                    navLabel={this.navLabel}/>;
                                            }}
                                        />
                                    </Switch>
                                </div>
                                <div
                                    id={"buttonTopdiv"}
                                    style={{ display: "none" }}
                                >
                                    <ButtonTop />
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </Router>
                </div>
            );
        } else {
            this.updateUrl();
            return (
                <div
                    style={{ margin: "auto", width: "86%", minHeight: "100vh" }}
                    className={styles.styleContent.concat(
                        " shadow bg-white rounded"
                    )}
                >
                    <Nav
                        reportStepProgress={this.state.stepProgressReport}
                        paginaReport={this.state.paginaReport}
                        profileDropdownList={menuUtente}
                        segnalazioni={this.state.notifiche}
                        filtri={this.state.filtri}
                        hiv={this.state.hiv}
                        navbarLink={this.state.hiv === true ? navLinksHIV : navLink}
                        navLabel={this.state.navLabel}
                    />
                    {window.location.pathname === "/login-callback" ? (
                        <div>
                            <div
                                className={"container"}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "5rem",
                                }}
                            >
                                <p
                                    style={{
                                        fontSize: "20px",
                                        textAlign: "center",
                                    }}
                                >
                                    <strong>
                                        Verifica autenticazione in corso
                                    </strong>
                                </p>
                            </div>
                        </div>
                    ) : (
                        <LogoutOrNotAuthorized
                            authorized={this.state.authorized}
                        />
                    )}
                </div>
            );
        }
    }

    //NEEDED to update navbar - React re-renders all components and sub-components every time setState is called
    updateUrl() {
        // console.log("[ROUTING] Requested route: " + window.location.pathname)
        if (this.state.url !== window.location.pathname) {
            let state = this.state;
            state.url = window.location.pathname;
            this.setState(state);
        }

        if (localStorage.getItem("scroll") !== "false") {
            window.scrollTo(0, 0);
        } else {
            $("html, body").animate({ scrollTop: $(document).height() }, 1);
            localStorage.setItem("scroll", "true");
        }

        if (
            window.location.pathname === "/home" ||
            window.location.pathname === "/inserimentoSegnalazioni" ||
            window.location.pathname === "/invioSchedeSpeciali" ||
            window.location.pathname === "/esitoTBC" ||
            window.location.pathname === "/reportEpatite" ||
            window.location.pathname === "/reportStatistici" ||
            window.location.pathname === "/ricercaFocolai" ||
            window.location.pathname === "/statoInvioPremal" ||
            window.location.pathname === "/exportSegnalazioni" ||
            window.location.pathname === "/exportArbovirosi" ||
            window.location.pathname === "/ricercaContactTracing"
        ) {
            sessionStorage.removeItem("parametriRicercaSegnalazioni");
        }
        if (
            window.location.pathname === "/home" ||
            window.location.pathname === "/inserimentoSegnalazioni" ||
            window.location.pathname === "/invioSchedeSpeciali" ||
            window.location.pathname === "/esitoTBC" ||
            window.location.pathname === "/reportEpatite" ||
            window.location.pathname === "/reportStatistici" ||
            window.location.pathname === "/ricercaSegnalazioni" ||
            window.location.pathname === "/statoInvioPremal" ||
            window.location.pathname === "/exportSegnalazioni" ||
            window.location.pathname === "/exportArbovirosi" ||
            window.location.pathname === "/ricercaContactTracing"
        ) {
            sessionStorage.removeItem("parametriRicercaFocolai");
        }
        if (
            window.location.pathname === "/home" ||
            window.location.pathname === "/inserimentoSegnalazioni" ||
            window.location.pathname === "/invioSchedeSpeciali" ||
            window.location.pathname === "/esitoTBC" ||
            window.location.pathname === "/reportEpatite" ||
            window.location.pathname === "/reportStatistici" ||
            window.location.pathname === "/ricercaSegnalazioni" ||
            window.location.pathname === "/statoInvioPremal" ||
            window.location.pathname === "/exportSegnalazioni" ||
            window.location.pathname === "/exportArbovirosi" ||
            window.location.pathname === "/ricercaFocolai"
        ) {
            sessionStorage.removeItem("parametriRicercaContactTracing");
        }
    }
}

export default AziendaZeroLayout;
